import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { RowTableBlock } from "./TableBlock";
import { ItemsInfo } from "@ugg/shared/api/data-parser/champions/items";

interface ItemsTableProps {
  className?: string;
  patch?: string;
  championItems: ItemsInfo;
}

export function ItemsTable(props: ItemsTableProps) {
  const { t } = useTranslation();
  const { className, championItems, patch } = props;

  const { starting_items, boots, items_1, items_2, items_3, items_4, items_5 } = championItems || {};

  return (
    <div className={classNames(className)}>
      <div className="flex flex-wrap gap-[12px]">
        <RowTableBlock
          className="flex-[1_1_480px] overflow-hidden"
          data={starting_items}
          title={t("Starting Items")}
          defaultSort={{ id: "pick_rate", desc: true }}
          spriteSize={30}
          patch={patch}
          ssr
          webp
        />
        <RowTableBlock
          className="flex-[1_1_480px] overflow-hidden"
          data={boots}
          title={t("Boots")}
          defaultSort={{ id: "pick_rate", desc: true }}
          spriteSize={30}
          patch={patch}
          ssr
          webp
        />
      </div>
      {[
        { data: items_1, title: t("Item 1") },
        { data: items_2, title: t("Item 2") },
        { data: items_3, title: t("Item 3") },
        { data: items_4, title: t("Item 4") },
        { data: items_5, title: t("Item 5") },
      ].map((block, index) => (
        <RowTableBlock
          key={index}
          data={block.data}
          title={block.title}
          defaultSort={{ id: "pick_rate", desc: true }}
          spriteSize={30}
          patch={patch}
          ssr
          webp
        />
      ))}
    </div>
  );
}
